import type { AddDeviceFormType } from "@/apps/partner/types";
import { FormOfAddresses } from "@/components/Portal/UserAccount/PersonalDetails/PersonalDetailsFormFields/PersonalDetailsFormFields";
import {
  SalesPartnerCreateCustomerLanguageEnum,
  SalesPartnerCreateCustomerSalutationEnum,
} from "@/services/model";
import type { HeaderModel } from "@/services/model/headerModel";
import type { PrepareBasketRequest } from "@/services/model/prepareBasketRequest";
import type { PrepareBasketRequestSimType } from "@/services/model/prepareBasketRequestSimType";
import type { SalesPartnerCreateCustomer } from "@/services/model/salesPartnerCreateCustomer";
import { getDeviceForProduct } from "@/utils/productMatrix";

/** Sales partner ID required by prepareBasket until baskets/all filtering is fixed server-side. */
const PREPARE_BASKET_PARTNER_ID = 12;

type PrepareBasketFormType = Pick<
  AddDeviceFormType,
  | "simType"
  | "simAlias"
  | "productId"
  | "onp"
  | "mail"
  | "customer"
  | "isExistingCustomer"
>;

export const transformFormDataToPrepareBasketRequest = (
  formData: PrepareBasketFormType,
  header: HeaderModel,
): PrepareBasketRequest => {
  let customer: SalesPartnerCreateCustomer | undefined;

  if (!formData.isExistingCustomer && formData.customer) {
    customer = {
      firstName: formData.customer.firstName,
      lastName: formData.customer.lastName,
      contactPhoneNumber: formData.customer.contactPhoneNumber,
      city: formData.customer.city,
      countryCodeAlpha2: formData.customer.countryCodeAlpha2.ALPHA2,
      houseNumber: formData.customer.houseNumber,
      street: formData.customer.street,
      zip: formData.customer.zip,
      languageEnum: formData.customer
        .languageEnum as SalesPartnerCreateCustomerLanguageEnum,
      salutationEnum:
        formData.customer.salutationEnum === FormOfAddresses.other.toString()
          ? SalesPartnerCreateCustomerSalutationEnum.MX
          : formData.customer.salutationEnum === FormOfAddresses.mr.toString()
            ? SalesPartnerCreateCustomerSalutationEnum.MR
            : SalesPartnerCreateCustomerSalutationEnum.MS,
      birthday: formData.customer.birthday,
      header,
    };
  }

  const request: PrepareBasketRequest = {
    header,
    partnerId: PREPARE_BASKET_PARTNER_ID,
    mail: formData.mail,
    onp: formData.onp === "true",
    productId: formData.productId,
    simAlias: formData.simAlias,
  };

  if (customer) {
    request.customer = customer;
  }

  if (formData.productId) {
    request.device = getDeviceForProduct(formData.productId).enum;
  }

  if (formData.simType) {
    request.simType = formData.simType as PrepareBasketRequestSimType;
  }

  return request;
};
